import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Alert, Spinner } from 'react-bootstrap';
import api from '../api/axios';
import AuthContext from '../context/AuthContext';
import TermsAgreement from '../components/TermsAgreement';
import SiteFooter from '../components/SiteFooter';

// 기존 회원 약관 재동의 페이지.
// 로그인은 됐지만 terms_agreed_at 이 없는 사용자를 ProtectedRoute 가 여기로 보낸다.
// 모달이 아니라 별도 라우트인 이유: 새로고침해도 가드가 다시 잡아 우회가 불가능하다.
const TermsAgreePage = () => {
    const navigate = useNavigate();
    const { refreshTermsStatus } = useContext(AuthContext);

    const [agreedTerms, setAgreedTerms] = useState(false);
    const [agreedPrivacy, setAgreedPrivacy] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const agreedAll = agreedTerms && agreedPrivacy;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!agreedAll) return;
        setError('');
        setSubmitting(true);
        try {
            await api.post('/auth/agree-terms');
            await refreshTermsStatus();
            navigate('/', { replace: true });
        } catch (err) {
            setError(err.response?.data?.errors?.[0]?.msg || '동의 처리에 실패했습니다. 잠시 후 다시 시도해주세요.');
            setSubmitting(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-form-panel" style={{ width: '100%' }}>
                <div className="login-form-wrapper" style={{ maxWidth: 480 }}>
                    <div className="login-form-header">
                        <h2 className="login-form-title">약관 동의</h2>
                        <p className="login-form-desc">
                            서비스 이용을 위해 아래 약관에 동의해 주세요.
                        </p>
                    </div>

                    <Alert variant="info">
                        매장 고객 정보의 처리위탁에 관한 조항이 신설되어 약관이 개정되었습니다.
                        내용을 확인하신 후 동의해 주세요.
                    </Alert>

                    {error && <Alert variant="danger">{error}</Alert>}

                    <form onSubmit={handleSubmit}>
                        <TermsAgreement
                            agreedTerms={agreedTerms}
                            agreedPrivacy={agreedPrivacy}
                            onChangeTerms={setAgreedTerms}
                            onChangePrivacy={setAgreedPrivacy}
                            disabled={submitting}
                        />

                        <Button
                            type="submit"
                            variant="primary"
                            className="login-submit w-100"
                            disabled={!agreedAll || submitting}
                        >
                            {submitting ? <><Spinner size="sm" className="me-2" />처리 중...</> : '동의하고 시작하기'}
                        </Button>
                    </form>

                    <SiteFooter />
                </div>
            </div>
        </div>
    );
};

export default TermsAgreePage;
